import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SubscriptionPlan } from "@/model/interface/SubscriptionPlan";

interface PlanIncludedProps {
  plan: SubscriptionPlan;
}

export function PlanIncluded({ plan }: PlanIncludedProps) {
  const allowances = [
    { label: "Seats", value: plan.unlimitedSeats ? "Unlimited" : plan.includedSeats.toLocaleString("en-US") },
    {
      label: "Phone numbers",
      value:
        typeof plan.includedPhoneNumbers === "number" ? plan.includedPhoneNumbers.toLocaleString("en-US") : "All included",
    },
    { label: "Call minutes a month", value: plan.includedOutboundCallMinutes.toLocaleString("en-US") },
    { label: "Texts a month", value: plan.includedOutboundSms.toLocaleString("en-US") },
  ];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
        <CardTitle className="text-xs font-bold uppercase tracking-wider text-muted-foreground">What's included</CardTitle>
        <Link to="/manage-organisation/billing/usage" className="text-sm font-medium text-primary hover:underline">
          See this cycle's usage
        </Link>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {allowances.map((allowance) => (
          <div key={allowance.label} className="rounded-lg border p-3">
            <p className="text-xs text-muted-foreground">{allowance.label}</p>
            <p className="text-lg font-semibold tabular-nums">{allowance.value}</p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
